module.exports = __webpack_public_path__ + "img/3a74ce3d0532b7773b174c45ca3bd05a_bigger.23bfe74b.png";